import { ChatActionTypes } from './chat.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    chatSendMessageSuccess: null,
    chatSendMessageError: null,
    chatSendMessageReqStatus: '',
    chatListSuccess: null,
    chatListError: null,
    messageListSuccess: null,
    messageListError: null
}

const chatReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST_SUCCESS:
            return {
                ...state,
                chatSendMessageSuccess: action.payload,
                chatSendMessageError: null,
                chatSendMessageReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST_ERROR:
            return {
                ...state,
                chatSendMessageSuccess: null,
                chatSendMessageError: action.payload,
                chatSendMessageReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST_STATUS:
            return {
                ...state,
                chatSendMessageReqStatus: ''
            }
        case ChatActionTypes.CHAT_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                chatListSuccess: action.payload,
                chatListError: null
            }
        case ChatActionTypes.CHAT_LIST_REQUEST_ERROR:
            return {
                ...state,
                chatListSuccess: null,
                chatListError: action.payload
            }
        case ChatActionTypes.MESSAGE_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                messageListSuccess: action.payload,
                messageListError: null
            }
        case ChatActionTypes.MESSAGE_LIST_REQUEST_ERROR:
            return {
                ...state,
                messageListSuccess: null,
                messageListError: action.payload
            }
        case ChatActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default chatReducer